// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.AssistantMessageList_content__1mZND {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 0 10px 15px 10px;
}

/* 自定义滚动条 */
.AssistantMessageList_content__1mZND::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.AssistantMessageList_content__1mZND::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.AssistantMessageList_content__1mZND::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.AssistantMessageList_item_box__ZDQcu {
    width: 100%;
    margin: 0 auto;
}

::selection {
    background-color: #cce2ff;
    color: rgba(0,0,0,.87);
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/AssistantMessageList/index.module.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,WAAW;AACX,yDAA6B,UAAU;IACnC,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,+DAAmC,WAAW;IAC1C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B","sourcesContent":["\n.content {\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    padding: 0 10px 15px 10px;\n}\n\n/* 自定义滚动条 */\n.content::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.content::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.content::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.item_box {\n    width: 100%;\n    margin: 0 auto;\n}\n\n::selection {\n    background-color: #cce2ff;\n    color: rgba(0,0,0,.87);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `AssistantMessageList_content__1mZND`,
	"item_box": `AssistantMessageList_item_box__ZDQcu`
};
export default ___CSS_LOADER_EXPORT___;
